import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const NAVY_ICON_SX = { color: 'var(--navy-main)', fontSize: 24 };
const NAVY_ACTION_STYLE = { color: 'var(--navy-main)' };

const EXPORT_PDF_ICON = <PictureAsPdfIcon sx={NAVY_ICON_SX} />;

/**
 * Row actions for the Form Submissions DataGrid (LongMenu).
 * @param {object} submission — raw API submission row
 * @param {{ onExportPdf?: (submission: object) => void }} handlers
 * @returns {readonly { title: string, onClick: () => void, id: string, icon: React.ReactNode, style: object }[]}
 */
export const getFormSubmissionRowActions = (submission, handlers) => {
  if (typeof handlers?.onExportPdf !== 'function') {
    return [];
  }
  return [
    {
      title: 'Export as PDF',
      onClick: () => handlers.onExportPdf(submission),
      id: 'export-pdf',
      icon: EXPORT_PDF_ICON,
      style: NAVY_ACTION_STYLE,
    },
  ];
};
